module.exports = __webpack_public_path__ + "img/pethouse03.4367fd5a.jpg";